export default function Message ({ children, isFromMe }) {
  const bubble = isFromMe
    ? 'bg-[#0B93F6] text-white rounded-2xl rounded-br-md'
    : 'bg-[#E9E9EB] text-black rounded-2xl rounded-bl-md'

  return (
    <div className={`flex px-3 py-0.5 ${isFromMe ? 'justify-end' : 'justify-start'}`}>
      <div className={`max-w-[75%] px-4 py-2 text-[15px] leading-snug shadow-sm break-words font-sans ${bubble}`}>
        {children}
      </div>
    </div>
  )
}
